import { useQuery, useQueryClient } from 'react-query'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../store/selectors/dealershipSelector'
import request from '../../request'
import { Vehicle } from '../../../lib/types/Vehicle'
import { useDealership } from '../../../store/zustand/dealershipStore'

export const useGetInventoryVehicle = (vin?: string) => {
  const dealership = useDealership()
  const queryClient = useQueryClient()
  return useQuery<Vehicle>(
    ['dealership', dealership?.id, 'inventory', 'vehicles', vin],
    ({ signal }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/inventory/${vin}`,
        method: 'GET',
        signal,
      }).then((res: any) => res.data),
    {
      placeholderData: () => {
        return (
          queryClient
            .getQueryData(['dealership', dealership?.id, 'inventory'], { exact: false })
            // @ts-ignore
            ?.data?.find((v: any) => String(v.vin) === String(vin))
        )
      },
      enabled: !!vin,
      refetchOnWindowFocus: false,
    },
  )
}
